// src/pages/DraftWars/draftWarsData.js
// Static seed data for Draft Wars — used to initialize the Firestore session.

// ─── Captain images ──────────────────────────────────────────────────────────
import AngieImg from "../../assets/draftwars/captains/Angie.JPG";
import CyberlawImg from "../../assets/draftwars/captains/Cyberlaw.JPG";
import DevImg from "../../assets/draftwars/captains/Dev.JPG";
import HalfADawgImg from "../../assets/draftwars/captains/HalfADawg.JPG";
import JonImg from "../../assets/draftwars/captains/Jon.JPG";
import MasakarImg from "../../assets/draftwars/captains/Masakar.JPG";
import TaeImg from "../../assets/draftwars/captains/Tae.JPG";
import WilesideImg from "../../assets/draftwars/captains/Wileside.JPG";

// ─── Player images (keyed by SEED_PLAYERS name) ──────────────────────────────
import AhmedImg from "../../assets/draftwars/players/Ahmed.JPG";
import AnnImg from "../../assets/draftwars/players/Ann.JPG";
import AstaImg from "../../assets/draftwars/players/Asta.JPG";
import BlirstImg from "../../assets/draftwars/players/Blirst.JPG";
import ChatGPTImg from "../../assets/draftwars/players/Chat-GPT.JPG";
import ChosenImg from "../../assets/draftwars/players/Chozen.JPG"; // note: filename typo
import CoreImg from "../../assets/draftwars/players/Core.JPG";
import CryptyImg from "../../assets/draftwars/players/Crypty.JPG";
import DemiImg from "../../assets/draftwars/players/Demi.JPG";
import XinImg from "../../assets/draftwars/players/Xin.JPG";
import RvssianImg from "../../assets/draftwars/players/DemonRvssian.JPG";
import GenImg from "../../assets/draftwars/players/Gen.JPG";
import IssuesImg from "../../assets/draftwars/players/Issues.JPG";
import JesseImg from "../../assets/draftwars/players/Jesse.JPG";
import KaidoImg from "../../assets/draftwars/players/Kaido.JPG";
import MariImg from "../../assets/draftwars/players/Mari.JPG";
import MedicImg from "../../assets/draftwars/players/Medic.JPG";
import MiloImg from "../../assets/draftwars/players/Milo.JPG";
import NishImg from "../../assets/draftwars/players/Nish.JPG";
import NocturnalImg from "../../assets/draftwars/players/Nocturnal.JPG";
import OddlyImg from "../../assets/draftwars/players/Oddly.JPG";
import ShujinImg from "../../assets/draftwars/players/Shujin.JPG";
import ShvzzyImg from "../../assets/draftwars/players/Shvzzy.JPG";
import SlayImg from "../../assets/draftwars/players/Slay.JPG";
import StclairImg from "../../assets/draftwars/players/Stclair.JPG";
import PetersonImg from "../../assets/draftwars/players/XoPeterson.JPG";
import YumaImg from "../../assets/draftwars/players/Yuma.JPG";
import ZealImg from "../../assets/draftwars/players/Zeal.JPG";
import ZeldrisImg from "../../assets/draftwars/players/Zeldris.JPG";
import ZendeyuhImg from "../../assets/draftwars/players/Zendeyuh.JPG";

export const CAPTAIN_IMAGES = {
  Angie: AngieImg,
  Cyberlaw: CyberlawImg,
  Dev: DevImg,
  HalfADawg: HalfADawgImg,
  Jon: JonImg,
  Masakar: MasakarImg,
  Tae: TaeImg,
  Wileside: WilesideImg,
};

export const PLAYER_IMAGES = {
  // S-Tier
  Crypty: CryptyImg,
  Milo: MiloImg,
  Peterson: PetersonImg,
  Oddly: OddlyImg,
  Blirst: BlirstImg,
  Zeal: ZealImg,
  Slay: SlayImg,
  // A-Tier
  Shvzzy: ShvzzyImg,
  Ann: AnnImg,
  Zeldris: ZeldrisImg,
  Nocturnal: NocturnalImg,
  Xin: XinImg,
  Medic: MedicImg,
  Stclair: StclairImg,
  Chosen: ChosenImg,
  Nish: NishImg,
  Rvssian: RvssianImg,
  Demi: DemiImg,
  Kaido: KaidoImg,
  Core: CoreImg,
  // B-Tier
  Jesse: JesseImg,
  Zendeyuh: ZendeyuhImg,
  Ahmed: AhmedImg,
  Gen: GenImg,
  Yuma: YumaImg,
  Issues: IssuesImg,
  Asta: AstaImg,
  "Chat-GPT": ChatGPTImg,
  Shujin: ShujinImg,
  Mari: MariImg,
};

// ─── Captains ────────────────────────────────────────────────────────────────
export const SEED_CAPTAINS = [
  { id: "angie",     name: "Angie",     color: "#DC2626" },
  { id: "cyberlaw",  name: "Cyberlaw",  color: "#EA580C" },
  { id: "dev",       name: "Dev",       color: "#D97706" },
  { id: "halfadawg", name: "HalfADawg", color: "#16A34A" },
  { id: "jon",       name: "Jon",       color: "#0891B2" },
  { id: "masakar",   name: "Masakar",   color: "#2563EB" },
  { id: "tae",       name: "Tae",       color: "#7C3AED" },
  { id: "wileside",  name: "Wileside",  color: "#DB2777" },
];

// ─── Players (30 total — 7 S-tier · 13 A-tier · 10 B-tier) ───────────────────
// 8 captains × 3 roster slots = 24 drafted, 6 players will go unsold.
export const SEED_PLAYERS = [
  // S-Tier (7)
  { id: "p_crypty",    name: "Crypty",    tier: "S", basePrice: 47000 },
  { id: "p_milo",      name: "Milo",      tier: "S", basePrice: 47000 },
  { id: "p_peterson",  name: "Peterson",  tier: "S", basePrice: 45000 },
  { id: "p_oddly",     name: "Oddly",     tier: "S", basePrice: 40000 },
  { id: "p_blirst",    name: "Blirst",    tier: "S", basePrice: 40000 },
  { id: "p_zeal",      name: "Zeal",      tier: "S", basePrice: 40000 },
  { id: "p_slay",      name: "Slay",      tier: "S", basePrice: 40000 },

  // A-Tier (13)
  { id: "p_shvzzy",    name: "Shvzzy",    tier: "A", basePrice: 35000 },
  { id: "p_ann",       name: "Ann",       tier: "A", basePrice: 35000 },
  { id: "p_zeldris",   name: "Zeldris",   tier: "A", basePrice: 33000 },
  { id: "p_nocturnal", name: "Nocturnal", tier: "A", basePrice: 33000 },
  { id: "p_xin",       name: "Xin",       tier: "A", basePrice: 33000 },
  { id: "p_medic",     name: "Medic",     tier: "A", basePrice: 33000 },
  { id: "p_stclair",   name: "Stclair",   tier: "A", basePrice: 33000 },
  { id: "p_chosen",    name: "Chosen",    tier: "A", basePrice: 30000 },
  { id: "p_nish",      name: "Nish",      tier: "A", basePrice: 30000 },
  { id: "p_rvssian",   name: "Rvssian",   tier: "A", basePrice: 30000 },
  { id: "p_demi",      name: "Demi",      tier: "A", basePrice: 30000 },
  { id: "p_kaido",     name: "Kaido",     tier: "A", basePrice: 28000 },
  { id: "p_core",      name: "Core",      tier: "A", basePrice: 28000 },

  // B-Tier (10)
  { id: "p_jesse",     name: "Jesse",     tier: "B", basePrice: 25000 },
  { id: "p_zendeyuh",  name: "Zendeyuh",  tier: "B", basePrice: 25000 },
  { id: "p_ahmed",     name: "Ahmed",     tier: "B", basePrice: 25000 },
  { id: "p_gen",       name: "Gen",       tier: "B", basePrice: 25000 },
  { id: "p_yuma",      name: "Yuma",      tier: "B", basePrice: 25000 },
  { id: "p_issues",    name: "Issues",    tier: "B", basePrice: 23000 },
  { id: "p_asta",      name: "Asta",      tier: "B", basePrice: 23000 },
  { id: "p_chatgpt",   name: "Chat-GPT",  tier: "B", basePrice: 23000 },
  { id: "p_shujin",    name: "Shujin",    tier: "B", basePrice: 23000 },
  { id: "p_mari",      name: "Mari",      tier: "B", basePrice: 20000 },
];

// ─── Session defaults ────────────────────────────────────────────────────────
export const SESSION_DEFAULTS = {
  budget: 120000,
  bidIncrement: 500,      // minimum raise allowed
  timerSeconds: 15,
  minBasePrice: 20000,    // lowest base price — informational only (cap removed)
  rosterSize: 3,          // players each captain drafts (4 total inc. captain)
};

// Quick-bid presets shown on the captain page
export const QUICK_BID_AMOUNTS = [500, 1000, 5000];

// Tier metadata (used for styling/badges)
export const TIER_META = {
  S: { label: "S-Tier", color: "#F59E0B", accent: "from-amber-500 to-orange-600" },
  A: { label: "A-Tier", color: "#6366F1", accent: "from-indigo-500 to-purple-600" },
  B: { label: "B-Tier", color: "#64748B", accent: "from-slate-500 to-slate-700" },
};
